import { render, staticRenderFns } from "./PlayerOptions.vue?vue&type=template&id=24f1e455&scoped=true&"
import script from "./PlayerOptions.vue?vue&type=script&lang=js&"
export * from "./PlayerOptions.vue?vue&type=script&lang=js&"
import style0 from "./PlayerOptions.vue?vue&type=style&index=0&id=24f1e455&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f1e455",
  null
  
)

export default component.exports